<script>
	import MenuItem from './MenuItem.svelte';

	import Icon from '../Icons/Icon';
	import { get } from "svelte/store";
	import AlertsStore from "../../Alerts/Store";
	import Spinner from "../Spinner/Spinner.svelte";
	import SpinnerSize from "../Spinner/SpinnerSize";
	import LoadState from "../../Enums/LoadState.js";

	let updateState = AlertsStore.meta.updateState;
	let minutesSinceUpdate = AlertsStore.helpers.minutesSinceUpdate;

	let refresh = () => {
		AlertsStore.actions.loadNewRemoteData();
	};
</script>

<style type="text/scss">
	.last-updated {

		div {
			overflow:auto;

			p {
				margin-top: 0;
				margin-bottom: 0;
			}
			p.fl {
				float:left;
			}
			p.refresh {
				float:right;
			}

			a {
				color: blue;
				text-decoration: underline;
				cursor:pointer;
				font-size:11px;
				line-height:18px;
			}
			a:hover {
				color:black;
			}

		}


	}
</style>

<MenuItem class="last-updated">
	<!-- <h1><img class="header-icon" alt="Last Updated" src={Icon.clock.regular} />Last Updated</h1> -->
	{#if $updateState != LoadState.LOADED}
		<div>
			<p style="text-align:center;margin:0px;overflow:auto;">
				<Spinner size={SpinnerSize.MINI} absolute={false} inline={true} />
			</p>
		</div>
	{:else if $minutesSinceUpdate === 1}
		<div>
			<p class="fl">Updated 1 min ago</p>
			<p class="refresh"><a href="javascript:;" on:click={refresh}>refresh</a></p>
		</div>
	{:else}
		<div>
			<p class="fl">Updated {$minutesSinceUpdate} mins ago</p>
			<p class="refresh"><a href="javascript:;" on:click={refresh}>refresh</a></p>
		</div>
	{/if}

</MenuItem>
